import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import LandingNavbar from './components/LandingNavbar';
import ScrollAnimation from './components/ScrollAnimation';
import Hero from './sections/Hero';
import Features from './sections/Features';
import InteractiveDemo from './sections/InteractiveDemo';
import USPs from './sections/USPs';
import Testimonials from './sections/Testimonials';
import Pricing from './sections/Pricing';
import CTA from './sections/CTA';
import Footer from './sections/Footer';

const LandingPage: React.FC = () => {
  // Set page title and meta tags
  useEffect(() => {
    document.title = 'TYVRA - Modern Project Management with AI-Powered Estimation';
    
    // Add meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Transform your project management with AI-powered estimation, real-time collaboration, and advanced analytics. Join 1000+ agile teams delivering faster.'
      );
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content =
        'Transform your project management with AI-powered estimation, real-time collaboration, and advanced analytics. Join 1000+ agile teams delivering faster.';
      document.head.appendChild(meta);
    }

    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      {/* Navigation */}
      <LandingNavbar />

      {/* Hero Section */}
      <Box id="hero">
        <Hero />
      </Box>

      {/* Features Section */}
      <ScrollAnimation animation="fadeSlideUp" delay={0.1}>
        <Box id="features">
          <Features />
        </Box>
      </ScrollAnimation>

      {/* Interactive Demo Section */}
      <ScrollAnimation animation="fadeSlideUp" delay={0.1}>
        <Box id="demo">
          <InteractiveDemo />
        </Box>
      </ScrollAnimation>

      {/* Benefits/USPs Section */}
      <ScrollAnimation animation="fadeSlideUp" delay={0.1}>
        <Box id="benefits">
          <USPs />
        </Box>
      </ScrollAnimation>

      {/* Testimonials Section */}
      <ScrollAnimation animation="fadeSlideUp" delay={0.1}>
        <Box id="testimonials">
          <Testimonials />
        </Box>
      </ScrollAnimation>

      {/* Pricing Section */}
      <ScrollAnimation animation="fadeSlideUp" delay={0.1}>
        <Box id="pricing">
          <Pricing />
        </Box>
      </ScrollAnimation>

      {/* CTA Section */}
      <ScrollAnimation animation="scale" delay={0.1}>
        <Box id="cta">
          <CTA />
        </Box>
      </ScrollAnimation>

      {/* Footer */}
      <Footer />
    </Box>
  );
};

export default LandingPage;

